import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['modal', 'link']

  connect() {
    this.handleKeydown = this.handleKeydown.bind(this)
    document.addEventListener('keydown', this.handleKeydown)
  }

  disconnect() {
    document.removeEventListener('keydown', this.handleKeydown)
  }

  open(event) {
    event.preventDefault()
    this.modalTarget.classList.add('is-visible')
  }

  close() {
    this.modalTarget.classList.remove('is-visible')
  }

  continue() {
    window.open(this.linkTarget.getAttribute('href'), '_blank', 'noopener')
    this.close()
  }

  handleKeydown(event) {
    if (event.key === 'Escape') this.close()
  }
}
